// components/Alert.js
import Swal from 'sweetalert2';

const showAlert = (isEditing, entityName = "Registro") => {
    Swal.fire({
        title: '¡Éxito!',
        text: isEditing
            ? `${entityName} actualizado correctamente`
            : `${entityName} creado correctamente`,
        icon: 'success',
        confirmButtonText: 'Aceptar'
    });
};

export default showAlert;
